// 헤더·사이드바 골격·지도 위 공용 컨트롤 등 여러 탭이 같이 쓰는 문구.
// 키는 "common.<key>" 로 부른다. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
const common = {
  ko: {
    "header.version": "version {version}",
    "header.langSwitch": "언어 선택",
    "header.lang.ko": "한국어",
    "header.lang.en": "EN",
    "header.userMenu": "사용자 메뉴",
    "header.adminPage": "관리자 페이지",
    "nav.lockedDuringMission": "미션 진행 중에는 화면을 이동할 수 없습니다.",

    // Sidebar
    "sidebar.selectFarm": "농장 선택",
    "sidebar.noFarms": "보유한 농장이 없습니다.",
    "sidebar.farmsAria": "농장 목록",
    "sidebar.tabsAria": "사이드바 탭",
    "sidebar.contentAria": "사이드바 내용",
    "sidebar.tabs.information": "정보",
    "sidebar.tabs.mission": "미션",
    "sidebar.tabs.data": "작물분석",
    "sidebar.tabs.energy": "에너지",

    // MobileHeaderRefreshButton
    "mobileRefresh.label": "데이터 새로고침",
    "mobileRefresh.missionRunning": "미션이 진행 중입니다. 새로고침하려면 먼저 미션을 중지하세요.",

    // CellSelectionBar
    "cellBar.selectedSuffix": "개 선택됨",
    "cellBar.none": "선택 없음",
    "cellBar.selectAll": "전체 선택",
    "cellBar.clear": "해제",
    "cellBar.cancel": "취소",
    "cellBar.confirmTitle": "선택한 셀 {count}개를 해제할까요",
    "cellBar.confirmBody": "이 농장을 보고 있는 다른 사람의 화면에서도 함께 사라집니다.",

    // FarmOverlay
    "farmOverlay.eyebrow": "운영 중인 농장",
    "farmOverlay.switch": "농장 전환",
    "farmOverlay.count": "{count}개",
    "farmOverlay.lockedDuringMission": "미션 진행 중에는 농장을 변경할 수 없습니다.",

    // FlightNote
    "flightNote.idle": "대기 중",
    "flightNote.offline": "드론 오프라인",
    "flightNote.landing": "착륙 중",
    "flightNote.returning": "복귀 중 · 이륙 지점으로 이동",
    "flightNote.flying": "비행 중",
    "flightNote.progressOfTotal": "{phase} · {done}/{total} 완료",
    "flightNote.progressCount": "{phase} · {done}개 구역 완료",
    "flightNote.powerUploaded": "전원 ON · 미션 업로드 완료",
    "flightNote.powerComplete": "전원 ON · 미션 완료",
    "flightNote.powerIdle": "전원 ON · 대기 중",

    // LogoutButton
    "logout.label": "로그아웃",

    // 3_Smartdronepage
    "dronePage.routeEditLocked": "미션 진행 중에는 경로를 수정할 수 없습니다.",
    "dronePage.embedMissingFarmId": "farmId 쿼리가 없습니다. 스트림 대상이 고정되지 않았습니다.",
    "dronePage.embedStreamTitle": "드론 스트림 임베드",

    // StreamFloat / DemoStreamFloat / DroneStreamViewer
    "stream.liveTitle": "라이브 스트림",
    "stream.defaultTitle": "드론 스트림",
    "stream.demoAria": "데모 드론 라이브 스트림",
    "stream.noUrl": "스트림 URL이 없습니다.",
    "stream.badge.live": "LIVE",
    "stream.badge.offline": "오프라인",
    "stream.badge.noStream": "스트림 없음",
    "stream.badge.returning": "복귀 중",

    // BatteryIcon
    "battery.aria": "배터리 {pct}%",
  },
  en: {
    "header.version": "version {version}",
    "header.langSwitch": "Language",
    "header.lang.ko": "한국어",
    "header.lang.en": "EN",
    "header.userMenu": "User menu",
    "header.adminPage": "Admin page",
    "nav.lockedDuringMission": "Navigation is locked while a mission is in progress.",

    // Sidebar
    "sidebar.selectFarm": "Select Farm",
    "sidebar.noFarms": "No farms available.",
    "sidebar.farmsAria": "Farms",
    "sidebar.tabsAria": "Sidebar tabs",
    "sidebar.contentAria": "Sidebar content",
    "sidebar.tabs.information": "Info",
    "sidebar.tabs.mission": "Mission",
    "sidebar.tabs.data": "Crop Analysis",
    "sidebar.tabs.energy": "Energy",

    // MobileHeaderRefreshButton
    "mobileRefresh.label": "Refresh data",
    "mobileRefresh.missionRunning": "Mission is running. Stop the mission before refreshing.",

    // CellSelectionBar
    "cellBar.selectedSuffix": " selected",
    "cellBar.none": "No selection",
    "cellBar.selectAll": "Select all",
    "cellBar.clear": "Clear",
    "cellBar.cancel": "Cancel",
    "cellBar.confirmTitle": (p) =>
      `Clear ${p.count} selected ${Number(p.count) === 1 ? "cell" : "cells"}?`,
    "cellBar.confirmBody": "They will also disappear for everyone else viewing this farm.",

    // FarmOverlay
    "farmOverlay.eyebrow": "Active farm",
    "farmOverlay.switch": "Switch farm",
    "farmOverlay.count": (p) => `${p.count} ${Number(p.count) === 1 ? "farm" : "farms"}`,
    "farmOverlay.lockedDuringMission": "You can't switch farms while a mission is in progress.",

    // FlightNote
    "flightNote.idle": "Standby",
    "flightNote.offline": "Drone offline",
    "flightNote.landing": "Landing",
    "flightNote.returning": "Returning · Heading to takeoff point",
    "flightNote.flying": "In flight",
    "flightNote.progressOfTotal": "{phase} · {done}/{total} done",
    "flightNote.progressCount": (p) =>
      `${p.phase} · ${p.done} ${Number(p.done) === 1 ? "zone" : "zones"} done`,
    "flightNote.powerUploaded": "Power ON · Mission uploaded",
    "flightNote.powerComplete": "Power ON · Mission complete",
    "flightNote.powerIdle": "Power ON · Standby",

    // LogoutButton
    "logout.label": "Logout",

    // 3_Smartdronepage
    "dronePage.routeEditLocked": "Route editing is not available during a mission.",
    "dronePage.embedMissingFarmId": "farmId query is missing. Stream target is not fixed.",
    "dronePage.embedStreamTitle": "Drone Stream Embed",

    // StreamFloat / DemoStreamFloat / DroneStreamViewer
    "stream.liveTitle": "Live Stream",
    "stream.defaultTitle": "Drone Stream",
    "stream.demoAria": "Demo Drone Live Stream",
    "stream.noUrl": "No stream URL",
    "stream.badge.live": "LIVE",
    "stream.badge.offline": "OFFLINE",
    "stream.badge.noStream": "NO STREAM",
    "stream.badge.returning": "RETURNING",

    // BatteryIcon
    "battery.aria": "Battery {pct}%",
  },
};

export default common;
